import { Component, OnInit } from '@angular/core';
import { CartDrawerManagerService } from '../cart-drawer/cart-drawer-manager.service';
import { HttpClient, HttpEventType, HttpRequest } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent implements OnInit {

  warehouse_location = "";
  ROUTE_WAREHOUSE_LOCATION = environment.api_location + "/getDatabase";

  username_main = "";

  constructor(private cartManager: CartDrawerManagerService, private http: HttpClient) { }

  ngOnInit(): void {
    this.http.get(this.ROUTE_WAREHOUSE_LOCATION).subscribe(response => {
      this.warehouse_location = response['warehouse'];
      this.username_main = response['username'];
    });
  }

  get cartCount() {
    return this.cartManager.cartItems.length;
  }

  toggleCart() {
    this.cartManager.toggleCart();
  }
}
